<template>

    <section class="hero flex">
        <div class="hero-body flex_block">
            <div class="container has-text-centered flex ">

                <IconLoader class="icon_loader" />
                <div class=" loading_logo">
                    <!-- <logoSight/> -->
                </div>
                    <!-- <h1 class="loading_title title is-size-2">Chargement</h1> -->

            </div>
        </div>
    </section>

</template>

<script>
import LogoSight from '@/components/layouts/logoSight'


export default {
    name: 'CandidateTokenError',
    components: {
        LogoSight
    },
    data(){
        return {}
    },
    computed: {

    },
    methods: {

    }
}

</script>

<style lang="scss">

.survey_section{
    display: flex;
    .hero{
        .flex_block{
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 200px;
        }
    }
}
.icon_loader{
    width: 50px;
    fill: $info;
    opacity: .5;
}
.loading_title{
    color: $info!important;
}
.loading_logo{
    width: 150px;
    margin: auto;
    opacity: .5;
    svg{
        fill: $info;
    }
}
</style>